import BookingTypes, { type BookingType } from '$/_const/trip/WhatHasBeenBookedType.ts';
import type { FixedBookingCategory } from '$/_const/trip/FixedBookingCategory.ts';

const BOOKING_CATEGORY_KEY: Record<BookingType, string> = {
  [BookingTypes.FLIGHT]: 'flight',
  [BookingTypes.STAY]: 'accommodation',
  [BookingTypes.TRANSPORT]: 'transport',
  [BookingTypes.ATTRACTION]: 'attraction',
  [BookingTypes.RESTAURANT]: 'restaurant',
  [BookingTypes.OTHER]: 'other',
};

export const bookingLabelKey = (booking: { bookingType: BookingType; category?: FixedBookingCategory }): string =>
  booking.category
    ? `tripCreateForm.whatHasBeenBooked.categoryLabels.${booking.category}`
    : `tripCreateForm.whatHasBeenBooked.categories.${BOOKING_CATEGORY_KEY[booking.bookingType]}`;
